import { companiesPerPage, revalidate } from "../../common/constants";
import Kompanije from "../../view/screens/Kompanije/Kompanije";
import { CompaniesListing, handleCompanyListing } from "../api/company";

interface PocetnaProps {
    companies: CompaniesListing[];
    total: number;
    page: number;
}
interface CompaniesResponse {
    data: CompaniesListing[];
    total: number;
}

export default function KompanijePage({
    companies,
    total,
    page,
}: PocetnaProps) {
    return <Kompanije companies={companies} total={total} page={page} />;
}

export async function getStaticPaths() {
    const compsTotal = await handleCompanyListing({ page: 1, perPage: 999 });
    const numOfPages = Math.ceil(compsTotal.total / companiesPerPage);

    const paths = Array.from(Array(numOfPages).keys()).map((k) => ({
        params: { page: (k + 1).toString() },
    }));

    return {
        paths,
        fallback: "blocking",
    };
}

export async function getStaticProps({ params }) {
    const { page } = params;
    const companies: CompaniesResponse = await handleCompanyListing({
        perPage: companiesPerPage,
        page: parseInt(page, 10),
    });

    console.log("page", companies);

    if (companies) {
        return {
            props: {
                companies: companies.data,
                total: companies.total,
                page: parseInt(page, 10),
            },
            revalidate: revalidate,
        };
    }

    if (!companies) {
        return {
            notFound: true,
            revalidate: revalidate,
        };
    }
}
